module.exports = __webpack_public_path__ + "img/eyebrow_female_straight_thick_mask.196e6fac.png";